export const getResellerWarranty=async(dynamoDBClient,id)=>{
    try {
        const params={
            TableName:"Resellers",
            IndexName:"ResellerID-index",
            KeyConditionExpression: 'ResellerID = :id',
            ExpressionAttributeValues: {
                ':id': id
            },
        }
        const data=await dynamoDBClient.query(params).promise()
        
        
        return data
    } catch (error) {
         throw new Error(error)
    }
}

export const getBaseStationWarranty=async(dynamoDBClient,id)=>{
    try {
        console.log("searching data",id)
        const params={
            TableName:"Gateways",
            FilterExpression: 'GatewayMAC = :id',
            ExpressionAttributeValues: {
                ':id': id
            },
        }
        const data=await dynamoDBClient.scan(params).promise()
        
        
        return data
    } catch (error) {
         throw new Error(error)
    }
}

export const getAllBaseStationWarranty=async(dynamoDBClient)=>{
    try {
        const params={
            TableName:"Gateways",
            ProjectionExpression:"GatewayMAC, Email, Firmware"
        }
        const data=await dynamoDBClient.scan(params).promise()
        
        
        return data
    } catch (error) {
         throw new Error(error)
    }
}

export const getBeaconsWarranty=async(dynamoDBClient,id)=>{
    try {
        const params={
            TableName:"Beacons",
            FilterExpression: 'Beacons = :id',
            ExpressionAttributeValues: {
                ':id': id
            },
        }
        const data=await dynamoDBClient.scan(params).promise()
        
        
        return data
    } catch (error) {
         throw new Error(error)
    }
}

export const getAllBeaconsWarranty=async(dynamoDBClient)=>{
    try {
        const params={
            TableName:"Beacons",
            ProjectionExpression:"BeaconMAC, Email, BeaconName"
        }
        const data=await dynamoDBClient.scan(params).promise()
        
        
        return data
    } catch (error) {
         throw new Error(error)
    }
}